module.exports = __webpack_public_path__ + "static/media/alerts.bc0e169f.svg";